/**
 * Strips formatting from phone number for submission
 * @param {string} phone - Phone number with formatting
 * @returns {string} - Clean phone number (digits only, no +1 prefix)
 */
export function stripPhone(phone) {
  let phoneValue = phone
  if (phoneValue.startsWith('+1')) {
    phoneValue = phoneValue.replace('+1', '')
  }
  return phoneValue.replace(/\D/g, '')
}
